// GUI generic button component
AFRAME.registerComponent('btn', {
    multiple: true,
    schema: {
        on: {default: 'click'},
        clickAction: {type: 'string'}
    },
    init: function() {
        var data = this.data;
        var el = this.el;
        el.className = 'clk';

        el.addEventListener('mouseenter', function() {
            this.setAttribute('scale','1.1 1.1 1.1');
        });
        el.addEventListener('mouseleave', function() {
            this.setAttribute('scale','1 1 1');
        });
        el.addEventListener(data.on, function() {
            var clickActionFunctionName = data.clickAction;
            console.log("BTN in button, clickActionFunctionName: "+clickActionFunctionName);
            var clickActionFunction = window[clickActionFunctionName];
            if (typeof clickActionFunction === "function") clickActionFunction();
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/btn.js
// module id = 2
// module chunks = 0